var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.show ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('v-btn', {
    staticClass: "modal__close",
    attrs: {
      "color": "primary",
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1), _c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "d-flex justify-center"
  }, [_vm.img.meta.youtube ? _c('youtube', {
    attrs: {
      "video-id": _vm.videoId
    }
  }) : _c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.img.thumb
    }
  })], 1)])], 1)])])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }